import React from 'react';
import { useSelector } from 'react-redux';
import { getHub } from '../../../components/App/selectors';
import Disclaimer from '../components/Disclaimer';
import { getAuthDisclaimer, getUserDocuments } from '../selectors';
import { isCyHub } from '../helpers/hubs';
import { getHubByRoutingHub } from 'helpers/hubs';

const DisclaimerContainer = () => {
  const documents = useSelector(getUserDocuments);
  const routingHub = useSelector(getHub);
  const currentHub = getHubByRoutingHub(routingHub);
  const disclaimerI18Key = useSelector(getAuthDisclaimer);
  const cyHub = isCyHub(currentHub?.KEY);
  return <Disclaimer documents={documents} textKey={disclaimerI18Key} isCyHub={cyHub} />;
};

export default DisclaimerContainer;
